import React from 'react';
import ComplaintsBoard from './ComplaintBoard';

const ResolvedComplaints = () => (
    <ComplaintsBoard
        statusFilter="solved"
        title="Resolved Complaints"
        subtitle="Complaints that have been closed out"
    />
);

export default ResolvedComplaints;